
// This file is GENERATED by 'scripts/generate-press-images-config.js'.
// Do NOT edit this file directly.
// To update press images, add/remove files from 'public/images/presskit'
// and then run 'npm start' (for dev) or 'npm run build' (for production).

const GENERATED_PRESS_IMAGES_DATA = {
  pressImages: [
  {
    "id": 1,
    "filename": "img_1785598653460_d07p4.webp",
    "displayFilename": "img_1785598653460_d07p4.webp",
    "category": "General",
    "alt": "Img_1785598653460_d07p4"
  },
  {
    "id": 2,
    "filename": "img_1785598659269_tq3ta.webp",
    "displayFilename": "img_1785598659269_tq3ta.webp",
    "category": "General",
    "alt": "Img_1785598659269_tq3ta"
  },
  {
    "id": 3,
    "filename": "img_1785598664005_sxy6h.webp",
    "displayFilename": "img_1785598664005_sxy6h.webp",
    "category": "General",
    "alt": "Img_1785598664005_sxy6h"
  },
  {
    "id": 4,
    "filename": "img_1785598673749_0a3h6.webp",
    "displayFilename": "img_1785598673749_0a3h6.webp",
    "category": "General",
    "alt": "Img_1785598673749_0a3h6"
  },
  {
    "id": 5,
    "filename": "img_1785598678401_ww7v8.webp",
    "displayFilename": "img_1785598678401_ww7v8.webp",
    "category": "General",
    "alt": "Img_1785598678401_ww7v8"
  },
  {
    "id": 6,
    "filename": "img_1785598694274_n5squ.webp",
    "displayFilename": "img_1785598694274_n5squ.webp",
    "category": "General",
    "alt": "Img_1785598694274_n5squ"
  },
  {
    "id": 7,
    "filename": "img_1785598704282_jwheg.webp",
    "displayFilename": "img_1785598704282_jwheg.webp",
    "category": "General",
    "alt": "Img_1785598704282_jwheg"
  },
  {
    "id": 8,
    "filename": "img_1785598711693_ost3d.webp",
    "displayFilename": "img_1785598711693_ost3d.webp",
    "category": "General",
    "alt": "Img_1785598711693_ost3d"
  }
],
};

export default GENERATED_PRESS_IMAGES_DATA;
  